import { useEffect, useState } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Header } from './Header'
import configurations from "../../Utility/ConfigUtility"
import { Mid } from '@mid/sdk'
import axios from 'axios'
import { NoSubscription } from './NoSubscription'
import { Support } from '../Support/Support'
import { NavigationRoutes } from '../../Constants/Routes'
import Insights from '../Insights/Insights'
import Visualize from '../Visualize/Visualize'
import { parseJwt } from '../../Utility/TokenUtility'
import GlobalContext from '../../Contexts/Global/GlobalContext'
import { PublicationDisplayNamesProvider } from '../../Contexts/PublicationDisplayNames/PublicationDisplayNamesContext'
import VisualizeByName from '../VisualizeByName/VisualizeByName'
import LocalStorage, { Keys } from '../../Storage/LocalStorage'
import { ChargeCodeProvider } from '../../Contexts/ChargeCode/ChargeCodeContext'
// import { FeedbackModalProvider } from '../../Contexts/FeedbackModal/FeedbackModalContext'
import DownloadData from '../DownloadData/DownloadData'
import Library from '../Library/Library'
import LandingPage from './LandingPage/LandingPage'
import { Footer } from '../Shared/Footer'
// import { FeedbackModal } from '../Modals/FeedbackModal/FeedbackModal'
import UserEndpoints from '../../Services/UserEndpoints'
import { useCreateToast } from '../../Hooks/useCreateToast'
import { rolesIncludeFeature } from '../../Utility/UserUtils'
import { CHART_MENU_TYPES } from '../../Hooks/useChartCategories'
import "../../Components/Shared/TokenInterceptor";

const Home = () => {

    const [subscriptions, setSubscriptions] = useState(null)
    const [getSubscriptionsInProgress, setGetSubscriptionsInProgress] = useState(false)
    const [allowChart, setAllowChart] = useState(false)

    const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    const siteUrl = isLocal ? "https://frontend-dev.msa-dev.mckinsey-solutions.com/msa-dev-global-growth-cube" : `${configurations.redirectBaseUrl}/${configurations.subPath}`;

    const { createErrorToast } = useCreateToast();
    const midConfig = ({
        fm,
        flow,
    }) => ({
        redirectUrl: configurations.redirectBaseUrl,
        logoutRedirectUrl: configurations.redirectBaseUrl + "/logout",
        loginInfo: {
            appId: configurations.clientId,
            oidcConfigUrl: configurations.oidcConfigUrl,
            authDriver: "mid",
            fm,
            flow,
        },
        landingFn: async () => {
            window.location.hash = "";
        },
    });

    const mid = new Mid(midConfig({
        path: configurations.paths.oidcAuthCodePKCE,
        flow: "auth_code",
    }));

    const { name, given_name, family_name } = parseJwt(mid.accessToken());
    LocalStorage.set(Keys.CURRENT_ACCESS_TOKEN, mid.accessToken())
    axios.defaults.headers.common['Authorization'] = `Bearer ${mid.accessToken()}`


    useEffect(() => {
        setGetSubscriptionsInProgress(true);
        UserEndpoints.getRoles(true)
            .then(res => {
                LocalStorage.set(Keys.ROLES, JSON.stringify(res.data));
                setAllowChart(rolesIncludeFeature(res.data, 'AllowChart'));
            })
            .catch(e => createErrorToast(e));
        UserEndpoints.getSubscriptions(siteUrl, true)
            .then(res => {
                setSubscriptions(res.data)
                if (res.data.length) {
                    let currentSubscription = null
                    if (res.data.length === 1) {
                        currentSubscription = res.data[0]
                    }
                    else if (LocalStorage.get(Keys.CURRENT_SUBSCRIPTION)) {
                        const storedSub = LocalStorage.get(Keys.CURRENT_SUBSCRIPTION);
                        currentSubscription = res.data.find(sub => sub.subscriptionId === storedSub.subscriptionId);
                    }
                    
                    if (currentSubscription) {
                        LocalStorage.set(Keys.CURRENT_SUBSCRIPTION, currentSubscription)
                        delete axios.defaults.headers.common['SubscriptionId'];
                        axios.defaults.headers.common['SubscriptionId'] = currentSubscription.subscriptionId
                        const currentAsset = currentSubscription.assets.find(item => item.siteUrl.indexOf(configurations.subPath) !== -1)
                        if (currentAsset) {
                            delete axios.defaults.headers.common['AssetId'];
                            axios.defaults.headers.common['AssetId'] = currentAsset.assetId
                            LocalStorage.set(Keys.CURRENT_ASSET, currentAsset)
                        }
                    }
                }
            })
            .catch(e => createErrorToast(e))
            .finally(() => {
                setGetSubscriptionsInProgress(false);
            })
    }, [siteUrl]);

    return (
        <BrowserRouter basename={`/${configurations.subPath}`}>
            <GlobalContext.Provider value={{ name: name, firstName: given_name, lastName: family_name }}>
                {
                    !getSubscriptionsInProgress
                        ? <ChargeCodeProvider>
                          <PublicationDisplayNamesProvider>
                            <Header
                                names={{
                                    name: name ? name : 'UU',
                                    firstName: given_name ? given_name : 'U',
                                    lastName: family_name ? family_name : 'U'
                                }}
                                subscriptions={subscriptions}
                                allowChart={allowChart}
                            />
                            <main>
                                {
                                    !getSubscriptionsInProgress && subscriptions && subscriptions.length && LocalStorage.get(Keys.CURRENT_SUBSCRIPTION)
                                        ? <Routes>
                                            {allowChart ? (
                                                <>
                                                    <Route
                                                        path={NavigationRoutes.VISUALIZE}
                                                        element={<Visualize menuType={CHART_MENU_TYPES.INTERACTIVE} chartBaseRoute={NavigationRoutes.VISUALIZE} />}
                                                    />
                                                    <Route
                                                        path={NavigationRoutes.VISUALIZEBYNAME}
                                                        element={<VisualizeByName menuType={CHART_MENU_TYPES.INTERACTIVE} chartBaseRoute={NavigationRoutes.VISUALIZE} />}
                                                    />
                                                    <Route
                                                        path={NavigationRoutes.MARKET_SNAPSHOT}
                                                        element={<Visualize menuType={CHART_MENU_TYPES.MARKET_SNAPSHOT} chartBaseRoute={NavigationRoutes.MARKET_SNAPSHOT} />}
                                                    />
                                                    <Route
                                                        path={NavigationRoutes.MARKET_SNAPSHOT_BY_NAME}
                                                        element={<VisualizeByName menuType={CHART_MENU_TYPES.MARKET_SNAPSHOT} chartBaseRoute={NavigationRoutes.MARKET_SNAPSHOT} />}
                                                    />
                                                </>
                                            ) : null}
                                            <Route path={NavigationRoutes.DOWNLOAD_DATA} element={<DownloadData />} />
                                            <Route path={NavigationRoutes.SUPPORT.FileName} element={<Support />} />
                                            <Route path={NavigationRoutes.INSIGHTS.ROOT} element={<Insights />} />
                                            <Route path={NavigationRoutes.REPORTS} element={<Library />} />
                                            <Route path='/*' element={<LandingPage />} />
                                        </Routes>
                                        : subscriptions && subscriptions.length === 0 ? <NoSubscription /> : null
                                }
                            </main>
                            <Footer />
                            {/* <FeedbackModal /> */}
                        </PublicationDisplayNamesProvider>
                          </ChargeCodeProvider>
                        : null
                }
            </GlobalContext.Provider>
        </BrowserRouter>
    )
}

export default Home;